if (document.querySelector('.js-openDropdownContent')) {
  document.querySelectorAll('.js-openDropdownContent').forEach(elem => {
    elem.addEventListener('click', event => {
      const eventTar = event.target;
      const dropdownContent = eventTar.closest('.dropdown-block__up').nextElementSibling;

      dropdownContent.style.maxHeight = `${dropdownContent.scrollHeight}px`;
      eventTar.remove();
    })
  })
}